import { Icon } from "@iconify/react";
import Compressor from "compressorjs";
import moment from "moment";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { Addmetatags } from "./config/addmetatags";
import { CheckWorkAdvisor } from "./config/checkWorkAdvisor";
import { RequestFetch } from "./config/requestFetch";
import { showURL } from "./config/studentpicURL";
import { httpConfig } from "./httpConfig";
import { ProtectedLogin } from "./protectedlogin";

const WardRoundAssessmentPage = (props) => {
  const location = useLocation();
  const cookie = new Cookies();
  const usertoken = cookie.get("tokenEstimate");

  // ตั้งค่าตัวแปร
  const navigat = useNavigate();
  const http = httpConfig();
  const { id, grp, sheet, workId, datework } = useParams();
  const [detailSheet, setDetailSheet] = useState([]);
  const [detailSheetName, setDetailSheetName] = useState();
  const [detailStudent, setDetailStudent] = useState([]);
  const [advisor, setAdvisor] = useState(() => {
    return JSON.parse(localStorage.getItem("advisor"));
  });
  const domID = (id) => {
    return document.getElementById(id);
  };
  const [pointArr, setPointArr] = useState([]);
  const [detailPoint, setDetailPoint] = useState([]);
  const [radioPoint, setRadioPoint] = useState([]);
  const [startEstimate, setStartEstimate] = useState(false);
  const [floatPoint, setFloatPoint] = useState(false);
  const [workscore, setWorkscore] = useState([]);
  const [switchpoint, setSwitchpoint] = useState();
  const [hidefloatpoint, setHidefloatpoint] = useState(false);
  const [filenameStudent, setFilenameStudent] = useState([]);

  const filterWorklocalStorage = localStorage.getItem("filterWork")
    ? JSON.parse(localStorage.getItem("filterWork"))
    : "";

  const statusDone = localStorage.getItem("done")
    ? JSON.parse(localStorage.getItem("done"))
    : "";
  const [statusWork, setStatusWork] = useState(false);

  const [statusHaveScore, setStatusHaveScore] = useState(false);
  const [fileimgcomment, setFileimgcomment] = useState();
  const [filepdfcomment, setFilepdfcomment] = useState();

  //รับข้อมูล topic
  const [thisTopicHead, setThisTopicHead] = useState([]);

  //ข้อมูล topic result
  const [headTopic, setHeadTopic] = useState();
  const [detailTopic, setDetailTopic] = useState();
  const [idOfStudent, setIdOfStudent] = useState();
  const [getEditOldDB, setGetEditOldDB] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [textEdit, setTextEdit] = useState();
  const [commentgroup, setCommentgroup] = useState(null);
  const [datashowImgcom, setDatashowImgcom] = useState([]);
  const [datashowPDFcom, setDatashowPDFcom] = useState([]);
  const [urliframeshowmodal, setUrlframeshowmodal] = useState();
  const http_mvc = "https://datasoft.co.th/mvc_eye_depart";
  // const http_mvc = "http://11.0.0.106/mvc_eye_depart";
  const refshowiframepdf = useRef(null);
  // เช็คการเข้าสู่ระบบ
  // CheckingLogin().then((res) => {
  //   if (!res) {
  //     console.log("ต้องออกจากระบบ");
  //     Swal.fire({
  //       icon: "error",
  //       title: "!!เข้าสู่ระบบล้มเหลว!!",
  //       text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
  //       showConfirmButton: false,
  //       timer: 1400,
  //     });
  //     setTimeout(() => {
  //       window.location.href = "/estimate";
  //     }, 1400);
  //   }
  // });
  ProtectedLogin(2);

  // console.log("!!!!!!!!!!error=>", hidefloatpoint);

  // ดึงข้อมูลประเภทงานประเมิน
  async function fetchGetSheetDetail(type) {
    // console.log("sheet is a >>", sheet);
    let thistype = type ? type : 1;
    let arrIDsheet = localStorage.getItem("getFloat")
      ? JSON.parse(localStorage.getItem("getFloat"))
      : "";

    // console.log("this get have arrIDsheet now looking here=>", arrIDsheet);
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        id: sheet,
      }),
    };

    let bodyrequest = {
      id: sheet,
    };
    // console.log("bodyrequest >>", bodyrequest);
    const thisarr = [];

    fetch(
      `${http}/sheetdetail`,
      RequestFetch("POST", { id: sheet }, usertoken)
    ).then((res) =>
      res.json().then(async (data) => {
        if (data[0]) {
          data.map(async (dataDetail, index) => {
            if (arrIDsheet[0]) {
              let pass = false;
              arrIDsheet.map((ele) => {
                if (ele.IDsheet === dataDetail.ID) {
                  pass = true;
                }
              });
              if (pass) {
                let bodyrequestchoice = {
                  id: dataDetail.ID,
                  type: thistype,
                };
                // console.log(
                //   "เมื่อผ่านมาแล้วข้อดูข้อมูลที่ยิง กับ sheetDetailChoice",
                //   bodyrequestchoice
                // );
                const result = await fetch(
                  `${http}/sheetDetailChoice`,
                  RequestFetch("POST", bodyrequestchoice, usertoken)
                ).then((res) =>
                  res.json().then((data) => {
                    if (data[0]) {
                      let arr = [];
                      let txt = [];
                      let cut = [];
                      data.map((ele, index) => {
                        arr.push({
                          score: ele.score,
                          sheetDetailId: ele.sheet_detail_id,
                        });
                        txt.push({
                          text: ele.txt,
                          point: ele.score,
                        });
                      });
                      setDetailPoint(txt);
                      // console.log("look this what is=>", arr);
                      return arr;
                    }
                  })
                );
                thisarr.push(result);
                // localStorage.setItem("cry", JSON.stringify(thisarr));
                if (!pointArr[0]) {
                  console.log("thisArr For PointARR", thisarr);
                  setPointArr(thisarr);
                }
                // setPointArr(thisarr);
                return result;
                // console.log("look------it do is match------>", thisarr);
                // localStorage.setItem("cry", JSON.stringify(thisarr));

                // setPointArr(thisarr.sort((a, b) => a - b));
              } else {
                let requestOptionChoiceDefault = {
                  method: "POST",
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    id: dataDetail.ID,
                    type: 1,
                  }),
                };

                let bodyrequestchoice2 = {
                  id: dataDetail.ID,
                  type: 1,
                };

                const result = await fetch(
                  `${http}/sheetDetailChoice`,
                  RequestFetch("POST", bodyrequestchoice2, usertoken)
                ).then((res) =>
                  res.json().then((data) => {
                    if (data[0]) {
                      let arr = [];
                      let txt = [];
                      let cut = [];
                      data.map((ele, index) => {
                        arr.push({
                          score: ele.score,
                          sheetDetailId: ele.sheet_detail_id,
                        });
                        txt.push({
                          text: ele.txt,
                          point: ele.score,
                        });
                      });
                      setDetailPoint(txt);
                      // console.log("look this what is=>", arr);
                      return arr;
                    }
                  })
                );
                thisarr.push(result);
                if (!pointArr[0]) {
                  setPointArr(thisarr);
                }
                // setPointArr(thisarr);
                // localStorage.setItem("cry", JSON.stringify(thisarr));
                return result;
                // console.log("look------it do not match------>", thisarr);
                // setPointArr(thisarr.sort((a, b) => a - b));
                // localStorage.setItem("cry", JSON.stringify(thisarr));
              }
            }
            if (!arrIDsheet[0]) {
              let requestOptionChoiceDefault = {
                method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  id: dataDetail.ID,
                  type: 1,
                }),
              };
              let bodychoicedefault = {
                id: dataDetail.ID,
                type: 1,
              };

              const result = await fetch(
                `${http}/sheetDetailChoice`,
                RequestFetch("POST", bodychoicedefault, usertoken)
              ).then((res) =>
                res.json().then((data) => {
                  // console.log("this a sheetDetailChoice", data);
                  if (data[0]) {
                    let arr = [];
                    let txt = [];
                    let cut = [];
                    data.map((ele, index) => {
                      arr.push({
                        score: ele.score,
                        sheetDetailId: ele.sheet_detail_id,
                      });
                      txt.push({
                        text: ele.txt,
                        point: ele.score,
                      });
                    });
                    setDetailPoint(txt);
                    // console.log("look this what is=>", arr);
                    return arr;
                  }
                })
              );

              thisarr.push(result);
              if (!pointArr[0]) {
                console.log(
                  "อันนี้เป็นตัวเลือกเมื่อยังไม่มีการเลือกรายการ",
                  thisarr
                );
                setPointArr(thisarr);
              }
              // setPointArr(thisarr);
              // localStorage.setItem("cry", JSON.stringify(thisarr));

              return result;
              // console.log("look------it do Normal------>", thisarr);
              // console.log("ยังไม่มี getFloat =>", thisarr);
              // setPointArr(thisarr.sort((a, b) => a - b));
            }
          });
          // console.log("(TwT)..................>", testArr);
          setDetailSheet(data);
        }
      })
    );

    fetch(`${http}/sheet`, RequestFetch("POST", { id: sheet }, usertoken)).then(
      (res) =>
        res.json().then((data) => {
          // console.log("SheetName", data);
          setDetailSheetName(data);
        })
    );
  }

  async function fetchChoice() {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        id: sheet,
      }),
    };

    let bodyrequest = {
      id: sheet,
    };

    const result = await fetch(
      `${http}/sheetDetailChoice`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (data[0]) {
          let arr = [];
          data.map((ele) => {
            arr.push(ele.score);
          });
          return arr;
        }
      })
    );
    return result;
  }

  // ข้อมูลนศพ
  function fetchGetStudentDetail(idstudent) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        id: idstudent.trim(),
      }),
    };

    let bodyrequest = {
      id: idstudent.trim(),
    };

    fetch(
      `${http}/studentDetail`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("studentDetail----!!!!", data, idstudent.trim());
        if (!data[0]) {
          navigat(`/listWork?timestamp=${new Date().getTime()}`);
        } else {
          //ตอนนี้ได้ข้อมูลนักเรียนคนเดียวกันซ้ำกันสองข้อมูลเพราะค้นหาตามเลขของนักศึกษา
          let arr_eduyear_student = [];
          data.map((ele, index) => {
            // if (ele.eduYear === datework.toString()) { //เช็คตามปีการศึกษา
            //   arr_eduyear_student.push(ele);
            // }
            if (index === parseInt(data.length) - 1) {
              //เอาค่าล่าสุด
              arr_eduyear_student.push(ele);
            }
          });
          console.log("Student Data:", arr_eduyear_student)
          setDetailStudent(arr_eduyear_student);
        }
      })
    );
  }

  // จัดการลบรูปที่เลือกออกจากรายการ
  function handleDeleteimageset(key) {
    let dataimg = props.ImageURL;
    let arr_newset = [];
    dataimg.map((ele, index) => {
      if (index !== key) {
        arr_newset.push(ele);
      }
    });
    props.setImageURL(arr_newset);
  }

  function handleDeletePdfset(key) {
    let datapdf = props.Pdfcomment;
    let newpdf_arrset = [];
    datapdf.map((ele, index) => {
      if (index !== key) {
        newpdf_arrset.push(ele);
      }
    });
    props.setPdfcomment(newpdf_arrset);
  }

  // ข้อมูลคะแนนงานประเมิน
  function fetchGetWorkDetailScore(ID, IDwk) {
    // console.log("what is this ========", ID, IDwk);
    // console.log("ทำงานWorkDetailScore อันนี้น้อ", radioPoint);
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        IdStudent: ID,
        Idwork: IDwk,
      }),
    };
    let bodyrequest = {
      IdStudent: ID,
      Idwork: IDwk,
    };

    fetch(
      `${http}/WorkDetailScore`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("look is here man ===>", data);
        // console.log("look arrpoin man ===>", pointArr.sort().length);
        if (statusUpdate) return;
        if (data[0]) {
          let object = {};
          let arr = [];

          if (!workscore[0]) {
            setWorkscore(data);
          }

          // console.log("datahave is =>", data);
          // console.log("datahave pointArr is =>", pointArr.sort());

          pointArr.sort().map((ele, index) => {
            let ascore;
            let pass = true;
            ele.map((point, pIndex) => {
              if (!ascore) {
                ascore = point.score;
              } else {
                if (ascore === point.score) {
                  // console.log("นี้ไง", point.sheetDetailId);
                  pass = false;
                }
              }
              if (pass) {
                data.map((data, index_res) => {
                  if (point.sheetDetailId === data.sheetID) {
                    if (point.score === data.score) {
                      // console.log(
                      //   "OK match ==>",
                      //   data.sheetID,
                      //   point.sheetDetailId,
                      //   data.score
                      // );
                      object = {
                        key: parseInt(data.sheetID),
                        index: pIndex,
                        value: data.score,
                        IDfrom: data.sheetID,
                      };
                      // console.log(
                      //   "this object set RadioPoint when fetch data",
                      //   object
                      // );
                      if (arr[0]) {
                        let add = true;
                        arr.map((arr_res) => {
                          if (arr_res.key === parseInt(data.sheetID)) {
                            add = false;
                          }
                        });
                        if (add) {
                          arr.push(object);
                        }
                      } else {
                        arr.push(object);
                      }
                    }
                  }
                });
              } else {
                // console.log("false", point.score);
                pass = true;
              }
            });
          });
          if (arr[0]) {
            setStatusHaveScore(true);
            setRadioPoint(arr);
          }
        }
      })
    );
  }

  // ข้อมูลหัวข้อเรื่องที่จะประเมินในงาน
  function fetchHeadSheetTopic(sheetId) {
    // console.log("this sheetId head>>", sheetId);
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ idsheet: sheetId }),
    };
    let bodyrequestheadtopic = {
      idsheet: sheetId,
    };
    fetch(
      `${http}/sheetHeadTopic`,
      RequestFetch("POST", bodyrequestheadtopic, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("headtopic", data);
        setThisTopicHead(data);
      })
    );
  }

  // ข้อมูลหัวข้อเรื่องงานที่ประเมิน
  function fetchWorkHeadTopic(idWork) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ workId: idWork }),
    };
    let bodyrequestWorkheadtopic = {
      workId: idWork,
    };
    fetch(
      `${http}/workHeadTopic`,
      RequestFetch("POST", bodyrequestWorkheadtopic, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("workhead TOPIC is =>", data);
        setDetailTopic(data);
      })
    );
  }

  // ข้อมูลงานที่จะประเมิน
  function fetchWorkDetail(stdID, IdWK) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        studentId: stdID,
        idwork: IdWK,
      }),
    };

    let bodyrequest = {
      studentId: stdID,
      idwork: IdWK,
    };

    return fetch(
      `${http}/workDetail`,
      RequestFetch("POST", bodyrequest, usertoken)
    );
  }

  function handlegetcommet(stdID, Idwork) {
    // console.log("แล้วข้อมูลคือ", stdID, Idwork);

    fetchWorkDetail(stdID, Idwork).then((res) =>
      res.json().then((data) => {
        if (data[0].note !== "") {
          setCommentgroup(data[0].note);
        }
      })
    );
  }

  function fetchCommentWorkDetail(comment, workid, studentid) {
    let bodyresquest = {
      comment: comment,
      workid: workid,
      studentid: studentid,
    };
    return fetch(
      `${http}/commentworkdetail`,
      RequestFetch("PUT", bodyresquest, usertoken)
    );
  }

  // ข้อมูล id นศพ
  function fetchGetIdofStudent(studentId, group, work) {
    let bodyrequest = {
      IdStudent: studentId,
      grpid: group,
      workid: work,
    };
    fetch(
      `${http}/studentGetId`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) => {
      res.json().then((data) => {
        setIdOfStudent(data[0].ID);
      });
    });
  }

  // ไฟล์งาน นศพ pdf
  function fetchGetstudentFile(id, grp, workId) {
    let group = grp === "null" ? 0 : grp;
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        studentID: id,
        grp: grp,
        workID: workId,
      }),
    };
    let bodyrequest = {
      studentID: id,
      grp: grp,
      workID: workId,
    };
    // console.log("รายการส่งไปเอาไฟล์", bodyrequest);
    fetch(
      `${http}/studentFilename`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        console.log("this a filename PDF was ==>", data);
        setFilenameStudent(data);
      })
    );
  }

  //เพิ่มข้อมูลคะแนนประเมินไปยัง ฐานข้อมูล
  function fetchAddWorkDetail(idWK, idSTD, advisorID) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        workId: idWK,
        studentId: idSTD,
        advisorId: advisorID,
      }),
    };

    let bodyrequest = {
      workId: idWK,
      studentId: idSTD,
      advisorId: advisorID,
    };

    fetch(
      `${http}/confirmAddWorkdetail`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        console.log(message);
      })
    );
  }

  // เพิ่มข้อมูลคะแนนในงาน
  function fetchAddWorkScore(IdWK, IdSheet, point) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        workId: IdWK,
        sheetId: IdSheet,
        score: point,
      }),
    };

    let bodyrequest = {
      workId: IdWK,
      sheetId: IdSheet,
      score: point,
    };
    fetch(
      `${http}/confirmaddWorkScore`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        console.log(message);
      })
    );
  }

  //อัพเดทข้อความคอมเม้น
  function fetchAddComment() {
    let bodyrequest = {};
  }

  // อัพเดทค่าคะแนนใหม่
  function fetchUpdateWorkScore(IDwkdetail, IDstdetail, scoreNEW) {
    // console.log("data for update =>", IDwkdetail, IDstdetail, scoreNEW);

    let requestOption = {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        IdWorkDetail: IDwkdetail,
        IdSheetDetail: IDstdetail,
        scoreNew: scoreNEW,
      }),
    };

    let bodyrequest = {
      IdWorkDetail: IDwkdetail,
      IdSheetDetail: IDstdetail,
      scoreNew: scoreNEW,
    };

    fetch(
      `${http}/editToScore`,
      RequestFetch("PUT", bodyrequest, usertoken)
    ).then((res) => {
      res.json().then((message) => {
        console.log(message);
      });
    });
  }

  function fetchAddWorkHead(idWk, haedId, value) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        workId: idWk,
        txt: haedId,
        txtval: value,
      }),
    };
    let bodyrequest = {
      workId: idWk,
      txt: haedId,
      txtval: value,
    };

    fetch(
      `${http}/confrimAddWorkHead`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        console.log(message);
      })
    );
  }

  // โชว์หัวข้อเรื่อง
  function handleshowDetailtopic(txt) {
    if (!detailTopic) return;
    let thisResult;
    // console.log("ข้อมูลก่อนจะทำการดึงข้อมูล", detailTopic);
    detailTopic.map((topic) => {
      if (topic.txt.trim().toString() === txt.trim().toString()) {
        thisResult = topic.txt_val;
      }
    });
    return thisResult;
  }

  // useEffect(() => {
  //   if (!thisTopicHead[1]) return;
  //   console.log("--->", thisTopicHead[1].txt.split("@")[1].split(";"));
  //   thisTopicHead[1].txt
  //     .split("@")[1]
  //     .split(";")
  //     .map((res) => {
  //       console.log("โชว์ input");
  //     });
  // }, [thisTopicHead]);

  // ข้อมูล นศพ ที่ทำการประเมิน

  console.log("detailStudent[0].eduYear",detailStudent[0])
  function handleShowHead(sheetType) {
    if (sheetType === "2") {
      if (!detailStudent[0]) {
        return (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        );
      }
      return detailStudent.map((data, index) => {
        return (
          <div className="header-topic-detail" key={index}>
            <div className="detail-student-assessment">
              <div className="image-student-assessment">
                <div className="img-box-relative">
                  <img
                    className="img-student-info"
                    // src={`${http}/viewImage/${id.trim()}.jpg`}
                    // src={`https://datasoft.co.th/estimate/image/student/${
                    //   filterWorklocalStorage
                    //     ? filterWorklocalStorage.ayear
                    //     : moment(new Date()).format("YYYY")
                    // }/${id.trim()}.jpg`}
                    src={showURL(id.trim())}
                    width={50}
                    height={50}
                  ></img>
                </div>
              </div>
              <div className="info-student-assessment">
                <p>{`ชื่อ : ${data.titlename} ${data.studentname} ${data.studentlname}`}</p>
                <p>{`รหัสประจำตัว : ${id}`}</p>
                <p>{`อาจารย์ : ${data.advisorname} ${data.advisorlname}`}</p>
              </div>
            </div>
            <div className="form-topic-detail">
              <div className="topic-form">
                <span>{`${thisTopicHead[0] ? thisTopicHead[0].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[0] ? thisTopicHead[0].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail-c">
              <span>{`สำหรับนศพ กลุ่ม ${
                detailStudent[0] ? detailStudent[0].groupname : ""
              }`}</span>
            </div>
            <div className="form-topic-detail"></div>
          </div>
        );
      });
    } else if (sheetType === "3") {
      if (!detailStudent[0]) {
        return (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        );
      }
      return detailStudent.map((data, index) => {
        return (
          <div className="header-topic-detail" key={index}>
            <div className="form-topic-detail-img">
              <img
                className="topic-img-student-info"
                // src={`${http}/viewImage/${id.trim()}.jpg`}
                // src={`https://datasoft.co.th/estimate/image/student/${
                //   filterWorklocalStorage
                //     ? filterWorklocalStorage.ayear
                //     : moment(new Date()).format("YYYY")
                // }/${id.trim()}.jpg`}
                src={showURL(id.trim())}
                width={50}
                height={50}
              ></img>
            </div>
            <div className="form-topic-detail">
              <div className="topic-form">
                <span>{`${
                  thisTopicHead[0] ? thisTopicHead[0].txt : ""
                } `}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[0] ? thisTopicHead[0].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail-c">
              <span>{`ปีการศึกษา ${moment(data?.eduYear)
                .add(543, "year")
                .format("YYYY")} กลุ่ม ${data.groupname}`}</span>
            </div>
            <div className="form-topic-detail">
              <span>{"ชื่อนศพ : "}</span>
              <span>{`${data.studentname} ${data.studentlname}`}</span>
            </div>
          </div>
        );
      });
    } else if (sheetType === "6") {
      // console.log("ตอนนี้ sheet = ?", sheetType);
      // console.log("ข้อมูล >", detailStudent);
      if (!detailStudent[0]) {
        return (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        );
      }
      return detailStudent.map((data, index) => {
        console.log("data for wardround=", data);
        return (
          <div className="header-topic-detail" key={index}>
            <div className="form-topic-detail-img">
              <img
                className="topic-img-student-info"
                // src={`${http}/viewImage/${id.trim()}.jpg`}
                // src={`https://datasoft.co.th/estimate/image/student/${
                //   filterWorklocalStorage
                //     ? filterWorklocalStorage.ayear
                //     : moment(new Date()).format("YYYY")
                // }/${id.trim()}.jpg`}
                src={showURL(id.trim())}
                width={50}
                height={50}
              ></img>
            </div>
            <div className="form-topic-detail">
              <div className="topic-form">
                <span>{"ชื่อนักศึกษา"}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>{`${data.studentname} ${data.studentlname}`}</span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* การวินิจฉัย */}
              <div className="topic-form">
                <span>{`${thisTopicHead[0] ? thisTopicHead[0].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[0] ? thisTopicHead[0].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              <div className="topic-form">
                <span>{`รหัส`}</span>
                <span>{`:`}</span>
              </div>
              <div className="detail-form">
                <span>{`${id}`}</span>
              </div>
            </div>
            <div className="form-topic-detail">
              <div className="topic-form">
                <span>{`ส่งอาจารย์`}</span>
                <span>{`:`}</span>
              </div>
              <div className="detail-form">
                <span>{`${advisor.advisor_name} ${advisor.advisor_lname}`}</span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* หอผู้ป่วย */}
              <div className="topic-form">
                <span>{`${
                  thisTopicHead[1] ? thisTopicHead[1].txt.split("@")[0] : ""
                }`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[1] ? thisTopicHead[1].txt.split("@")[0] : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* ชื่อผู้ป่วย */}
              <div className="topic-form">
                <span>{`${thisTopicHead[2] ? thisTopicHead[2].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[2] ? thisTopicHead[2].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* เลขที่โรงพยาบาล */}
              <div className="topic-form">
                <span>{`${thisTopicHead[3] ? thisTopicHead[3].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[3] ? thisTopicHead[3].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* วันที่ผู้ป่วย admit */}
              <div className="topic-form">
                <span>{`${
                  thisTopicHead[4] ? thisTopicHead[4].txt : ""
                } `}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    thisTopicHead[4] ? thisTopicHead[4].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* วันที่จ่าย/รับผู้ป่วย */}
              <div className="topic-form">
                <span>{`${thisTopicHead[5] ? thisTopicHead[5].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    //เปลี่ยนวันที่สลับกัน อาจจะผิดที่ตัว back ลงข้อมูล ส่งค่า เวลาสลับ
                    thisTopicHead[5] ? thisTopicHead[5].txt : ""
                  )}
                </span>
              </div>
            </div>
            <div className="form-topic-detail">
              {/* วันที่ส่งรายงานผู้ป่วย */}
              <div className="topic-form">
                <span>{`${thisTopicHead[6] ? thisTopicHead[6].txt : ""}`}</span>
                <span>{":"}</span>
              </div>
              <div className="detail-form">
                <span>
                  {handleshowDetailtopic(
                    //เปลี่ยนวันที่สลับกัน อาจจะผิดที่ตัว back ลงข้อมูล ส่งค่า เวลาสลับ
                    thisTopicHead[6] ? thisTopicHead[6].txt : ""
                  )}
                </span>
              </div>
            </div>
          </div>
        );
      });
    } else {
      if (!detailStudent[0]) {
        return (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        );
      }
      return detailStudent.map((data, index) => {
        return (
          <div className="detail-student-assessment" key={index}>
            <div className="image-student-assessment">
              <div className="img-box-relative">
                <img
                  className="img-student-info"
                  // src={`${http}/viewImage/${id.trim()}.jpg`}
                  // src={`https://datasoft.co.th/estimate/image/student/${
                  //   filterWorklocalStorage
                  //     ? filterWorklocalStorage.ayear
                  //     : moment(new Date()).format("YYYY")
                  // }/${id.trim()}.jpg`}
                  src={showURL(id.trim())}
                  width={50}
                  height={50}
                ></img>
              </div>
            </div>
            <div className="info-student-assessment">
              <p>{`ชื่อ : ${data.titlename} ${data.studentname} ${data.studentlname}`}</p>
              <p>{`รหัสประจำตัว : ${id}`}</p>
              <p>{`อาจารย์ : ${data.advisorname} ${data.advisorlname}`}</p>
            </div>
          </div>
        );
      });
    }
  }

  // ถอด/เข้า รหัสข้อมูล file
  function handleDataURLBlob(dataURI) {
    if (!dataURI) return;
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  // หัวใจหลัก ฟังชั่น สำหรับแปลง PDF เป็น รูป
  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  // ฟังชั่นเพื่อสร้างตัว pdf ขึ้นมาอีกครั้ง
  const generatePDF = async (urlpdf_arr, pdf_width, pdf_height) => {
    let pdfDoc = await PDFDocument.create();
    for (let pageDAta of urlpdf_arr) {
      let page = pdfDoc.addPage([pdf_width, pdf_height]);

      let pdf_url = pageDAta.imgres_bloa;
      let imgByte = await fetch(pdf_url).then((res) => res.arrayBuffer());
      let img = await pdfDoc.embedJpg(imgByte);
      let imgDims = img.scale(1);
      page.drawImage(img, {
        x: 0,
        y: 0,
        width: imgDims.width,
        height: imgDims.height,
      });
    }

    let pdfByte = await pdfDoc.save();
    let blob = new Blob([pdfByte], { type: "application/pdf" });
    return blob;
  };

  //อ่านไฟล์เพื่อรับค่า drawImage และ URLdata
  const arr_reusltbloa = [];
  const [viewwidth, setViewwidth] = useState(null);
  const [viewheight, setViewheight] = useState(null);
  function handlefilereader(file) {
    // console.log("file >>", file);
    if (file.length === 0) return;
    if (file.type === "application/pdf") {
      // console.log("PDF !!!");
      //เมื่อรับไฟล์มาเป็น PDF
      //ทำการสร้างไฟล์เพื่อให้อยู่ในรูปแบบของรูปภาพและแสดง
      let fileReaderforpdf = new FileReader();
      fileReaderforpdf.onload = async (e) => {
        let pdfData = e.target.result;
        let pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
        let numofpage = pdf.numPages;
        for (let numpages = 1; numpages <= numofpage; numpages++) {
          document.getElementById("modashowloadingpdf").style.display = "block";
          let page = await pdf.getPage(numpages);
          let viewport = page.getViewport({ scale: 2 });
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          setViewwidth(viewport.width);
          setViewheight(viewport.height);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          let renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          await page.render(renderContext).promise;
          let imageDataUrl = canvas.toDataURL("image/jpeg");
          new Compressor(dataURLtoFile(imageDataUrl, "converted.jpeg"), {
            quality: 0.4,
            success(result) {
              // console.log("ทำการเพิ่มข้อมูลต่อหน้า", numpages, numofpage);
              arr_reusltbloa.push({
                page: numpages,
                imgres_bloa: URL.createObjectURL(result),
              });
              if (numpages === numofpage) {
                // console.log("ทำงานเสร็จ pdf");
                let result_genPDF = generatePDF(
                  arr_reusltbloa,
                  viewport.width,
                  viewport.height
                );
                result_genPDF.then((res) => {
                  // console.log("ข้อดูตัว gen", res);
                  setFilepdfcomment({ res: res, name: file.name });
                });
                document.getElementById("modashowloadingpdf").style.display =
                  "none";
              }
            },
            error(err) {
              console.log("dataURLtofile fail...", err);
            },
          });
        }
      };
      fileReaderforpdf.readAsArrayBuffer(file);
    } else {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function (e) {
        let imageReader = new Image();
        imageReader.src = e.target.result;
        imageReader.onload = function () {
          let canvasimage = document.createElement("canvas");
          let context = canvasimage.getContext("2d");
          canvasimage.width = imageReader.width;
          canvasimage.height = imageReader.height;
          context.drawImage(imageReader, 0, 0);
          let urlimagedraw = canvasimage.toDataURL("image/jpeg", 1.0);
          setFileimgcomment(urlimagedraw);
        };
      };
    }
  }

  function uploadImagecomment() {
    if (!props.ImageURL[0]) return;
    let data_img = props.ImageURL;
    let fileArr = [];

    data_img.map((ele, index) => {
      let blob = handleDataURLBlob(props.ImageURL[index]);
      let file = new File(
        [blob],
        `imgcomment-${workId}-${id}-${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes()}${index}.jpeg`,
        {
          type: "image/jpeg",
        }
      );
      fileArr.push(file);
    });

    fileArr.map((file_res) => {
      // console.log("file_res", file_res);
      let fileUPload = new FormData();
      fileUPload.append("file", file_res);
      fileUPload.append("std_id", `${id}`);
      // console.log("fileUPload is ", fileUPload.get("file"));
      fetchImageComment(fileUPload);
    });
  }

  console.log("FILE:", filenameStudent)

  function uploadPDFcomment() {
    if (!props.Pdfcomment[0]) return;
    let data_img = props.Pdfcomment;
    let fileArr_pdf = [];
    // console.log("data_img ===>", data_img);
    data_img.map((ele, index) => {
      let file = new File(
        [ele.promise_data],
        `PDFcomment-${workId}-${id}-${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes()}${index}.pdf`,
        { type: "application/pdf" }
      );
      fileArr_pdf.push(file);
    });

    fileArr_pdf.map((file_res) => {
      // console.log("file_res", file_res);
      let fileUPload = new FormData();
      fileUPload.append("file", file_res);
      fileUPload.append("std_id", `${id}`);
      // console.log("fileUPload is ", fileUPload.get("file"));
      fetchImageComment(fileUPload);
    });
  }

  //ทำการยิงอัพโหลดรูปภาพ
  function fetchImageComment(thisfile) {
    let resquestOption = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${usertoken}`,
      },
      body: thisfile,
    };
    // console.log('ตอนนี้จะอัพโหลดรูปภาพไปแล้ว',http_mvc)
    fetch(`${http_mvc}/student/upload_image_comment`, resquestOption)
      .then((res) =>
        res.json().then((data) => {
          if (data.status) {
            console.log("upload sccuess");
            // console.log(data.success);
          } else {
            console.log("upload fail");
          }
        })
      )
      .catch((err) => console.error("fail fetch upload img", err));
  }
  //รับข้อมูล URL ของรูปภาพ เมื่อมีการคอมเม้น
  function fetchGetImageComment() {
    if (!id) return;
    let objectforfetch = {
      std_id: id,
      work_id: workId,
    };
    // console.log("url", http_mvc);
    // console.log(
    //   "ดูรายการที่ยิงก่อน request ยังไง",
    //   RequestFetch("POST", objectforfetch, "")
    // );
    fetch(
      `${http_mvc}/student/getupload_image_comment`,
      RequestFetch("POST", objectforfetch, "")
    )
      .then((res) =>
        res.json().then((data) => {
          if (data.status) {
            let arr_result = [];
            data.result.map((ele) => {
              arr_result.push(`https://${ele.url}`);
              // arr_result.push(`http://${ele.url}`);
            });
            // props.setImageURL(arr_result);
            // console.log("ดู result เมื่อดึง รูปคอมเม้น", arr_result);
            setDatashowImgcom(arr_result);
          }
        })
      )
      .catch((err) => console.error("fail fetch", err));
  }

  //รับข้อมูล URL ของPDF เมื่อมีการคอมเม้น
  function fetchGetPDFcomment() {
    if (!id) return;
    let objectforfetch = {
      std_id: id,
      work_id: workId,
    };
    fetch(
      `${http_mvc}/student/getupload_PDF_comment`,
      RequestFetch("POST", objectforfetch, "")
    )
      .then((res) =>
        res.json().then((data) => {
          if (data.status) {
            let arr_result = [];
            data.result.map((ele) => {
              // console.log("ขอลิงค์ PDF==>", `https://${ele.url}`);
              arr_result.push(`https://${ele.url}`);
            });
            setDatashowPDFcom(arr_result);
          }
        })
      )
      .catch((err) => console.error("fail fetch", err));
  }

  useEffect(() => {
    if (!fileimgcomment) return;
    if (props.ImageURL[0]) {
      let dataimage = props.ImageURL;
      props.setImageURL([...dataimage, fileimgcomment]);
    } else {
      props.setImageURL([fileimgcomment]);
    }
  }, [fileimgcomment]);

  useEffect(() => {
    if (!filepdfcomment) return;
    console.log("filepdfcomment ..>!!");
    if (props.Pdfcomment[0]) {
      let datapdf = props.Pdfcomment;
      props.setPdfcomment([
        ...datapdf,
        {
          promise_data: filepdfcomment.res,
          filename: filepdfcomment.name,
        },
      ]);
    } else {
      props.setPdfcomment([
        { promise_data: filepdfcomment.res, filename: filepdfcomment.name },
      ]);
    }
  }, [filepdfcomment]);

  useEffect(() => {
    if (urliframeshowmodal) {
      // document.getElementById("modalshowiframpdf").style.display = "block";
      window.open(`${urliframeshowmodal}`, "_blank");
    }
  }, [urliframeshowmodal]);

  // console.log("arrคะแนน", pointArr);

  useEffect(() => {
    // console.log("ทำงานหลายรอบมาก");
    if (statusDone[0]) {
      statusDone.map((data) => {
        if (workId.toString() === data.wkID) {
          setStatusWork(true);
          setTimeout(() => {
            document.getElementById("NavAssesment").style.backgroundColor =
              "#33691e";
          }, 200);
        }
      });
    }
  }, [statusDone]);

  useEffect(() => {
    if (!id) return;
    fetchGetSheetDetail();
    fetchGetStudentDetail(id);
    fetchGetIdofStudent(id, grp, workId);
    fetchHeadSheetTopic(sheet);
    fetchWorkHeadTopic(workId);
  }, [id]);

  useEffect(() => {
    if (localStorage.getItem("getFloat")) {
      let dataId = JSON.parse(localStorage.getItem("getFloat"));

      dataId.map((ele) => {
        if (document.getElementById(`icon-chevron-right-${ele.IDsheet}`)) {
          document.getElementById(`icon-chevron-right-${ele.IDsheet}`).click();
          setFloatPoint(true);
        }
      });
    }
  }, [localStorage.getItem("getFloat")]);

  useEffect(() => {
    Addmetatags();
    localStorage.removeItem("getFloat");
    if (sheet.toString().trim() === "6") {
      setHidefloatpoint(false); //ปรับเป็น fasle ปิดไว้ก่อน
    }
    if (sheet.toString().trim() === "5") {
      setHidefloatpoint(false); //ปรับเป็น fasle ปิดไว้ก่อน
    }
    fetchGetImageComment();
    fetchGetPDFcomment();
    if (!usertoken) {
      Swal.fire({
        icon: "error",
        title: "!!เข้าสู่ระบบล้มเหลว!!",
        text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
        showConfirmButton: false,
        timer: 1400,
      });
      setTimeout(() => {
        window.location.href = "/estimate";
        cookie.remove("tokenEstimate");
      }, 1400);
    }
    if (localStorage.getItem("point_radio")) {
      setRadioPoint(JSON.parse(localStorage.getItem("point_radio")));
      localStorage.removeItem("point_radio");
    }
    if (localStorage.getItem("stu_e")) {
      setStatusUpdate(JSON.parse(localStorage.getItem("stu_e")));
      localStorage.removeItem("stu_e");
    }
    if (localStorage.getItem("cmm")) {
      // console.log("มีไหมอ้าย มีไหม", JSON.parse(localStorage.getItem("cmm")));
      setCommentgroup(JSON.parse(localStorage.getItem("cmm")));
      localStorage.removeItem("cmm");
    }
    if (localStorage.getItem("advisor")) {
      let storageAdvisor = JSON.parse(localStorage.getItem("advisor"));
      // console.log("ตอนนี้ดูรายการของ advisor >>>>", storageAdvisor);
      CheckWorkAdvisor(storageAdvisor.advisor_id, workId, usertoken).then(
        (res) => {
          if (!res) {
            navigat("/page404");
          }
        }
      );
    }
  }, [location.search]);

  useEffect(() => {
    if (!idOfStudent) return;
    if (!pointArr) return;
    // if (commentgroup && filenameStudent[0] && radioPoint[0] && workscore[0])
    //   return;
    // console.log("ทำงานกี่ครั้ง!!",pointArr);
    // console.log("this a stat pintArr=>", pointArr);
    // console.log("datasheet=>", detailSheet);
    fetchGetWorkDetailScore(idOfStudent, workId);
    fetchGetstudentFile(idOfStudent, grp, workId);
    handlegetcommet(idOfStudent, workId);
    // console.log("that data pointArr -=>", pointArr);
    // pointArr.map((testdata) => {
    //   console.log("test map stat piontArr=>", testdata);
    // });
  }, [idOfStudent, pointArr]);

  useEffect(() => {
    if (workscore[0]) {
      setGetEditOldDB(true);

      // console.log(">>>>>>>>", workscore);
      workscore.map((res) => {
        if (res.score.toString().split(".")[1]) {
          // console.log("นิเศษ มี =>", res.sheetID);
          if (localStorage.getItem("getFloat")) {
            let arrLocal = JSON.parse(localStorage.getItem("getFloat"));
            let objectNew = {
              IDsheet: res.sheetID,
            };
            let pass = true;
            arrLocal.map((ele) => {
              if (ele.IDsheet === res.sheetID) {
                pass = false;
              }
            });

            if (pass) {
              arrLocal.push(objectNew);
              localStorage.setItem("getFloat", JSON.stringify(arrLocal));
            }
          } else {
            localStorage.setItem(
              "getFloat",
              JSON.stringify([{ IDsheet: res.sheetID }])
            );
          }
        }
      });
    }
  }, [workscore]);

  // useEffect(() => {
  //   console.log("Now radioPoint ==>", radioPoint);
  // }, [radioPoint]);

  // เมื่อมีการกดเปลี่ยนแปลงคะแนน
  async function handleSwitchPoint(mode, id, sheetId) {
    // console.log("ได้ค่า", mode, id, sheetId);
    switch (mode) {
      case "float":
        setTimeout(() => {
          domID(`icon-chevron-right-${sheetId}`).style.display = "none";
          domID(`icon-chevron-left-${sheetId}`).style.display = "block";
        }, 200);

        // console.log("this type change to float", sheetId);
        let bodyrequest = {
          sheetID: sheetId,
        };

        let typeChoice = await fetch(
          `${http}/checkDetailChoice`,
          RequestFetch("POST", bodyrequest, usertoken)
        ).then((res) => res.json());

        // console.log("this is a =>", typeChoice);
        typeChoice.map((res) => {
          if (res.type === "2") {
            // console.log("this 2 =>", res.type);
            fetchGetSheetDetail(res.type);
          }
          fetchGetSheetDetail(res.type);
        });
        break;

      case "int":
        setTimeout(() => {
          domID(`icon-chevron-left-${sheetId}`).style.display = "none";
          domID(`icon-chevron-right-${sheetId}`).style.display = "block";
        }, 200);

        await fetchGetSheetDetail();
        break;
      default:
        break;
    }
  }

  // เมื่อคลิกคะแนน
  function checkRadioButton(data, key, sheetDetailId, index, result, IDtb) {
    let value = {
      key: sheetDetailId,
      index: index,
      value: result,
      IDfrom: IDtb,
    };
    // console.log("objectToset=>", value);
    // console.log("dataRadioPoint=>", data);

    if (data[0]) {
      let arr = [];
      let lenght = radioPoint.length;

      // console.log(data);
      // console.log(lenght - 1, key);

      let pass = true;
      data.map((res) => {
        if (res.key === sheetDetailId) {
          pass = false;
        }
      });
      if (pass) {
        arr.push(value);
      }
      // console.log("pass =>", pass);

      data.map((res, inres) => {
        if (res.key === sheetDetailId) {
          // console.log("เข้าเงื่อนไขนี้ใช่ไหม");
          if (res.value !== result) {
            // console.log("value ไม่เท่ากัน ", arr);
            if (arr) {
              let arrpass = true;
              arr.map((ele) => {
                if (ele.key === sheetDetailId) {
                  arrpass = false;
                }
              });
              if (arrpass) {
                arr.push(value);
              }
            } else {
              arr.push(value);
            }
          }
        }
        if (res.key !== sheetDetailId) {
          // console.log("ไม่มี คีนั้นนี้", res.key);
          arr.push(res);
        }
      });

      // console.log("newDATA >>>>", arr);
      setRadioPoint(arr);
    } else {
      setRadioPoint([value]);
    }
  }

  function handleCutValuePoint(key) {
    let arr = [];
    radioPoint.map((data) => {
      if (data.key !== key) {
        arr.push(data);
      }
    });
    // console.log("cut Radiopoint with =>", key);
    setRadioPoint(arr);
  }

  // เมื่อคลิกคะแนน
  function radioChecked(data, Id, point) {
    if (!data[0]) return;
    // console.log("this data to come =>", data);
    let result = false;
    data.map((res) => {
      if (res.IDfrom === Id) {
        if (res.value === point) {
          result = true;
        }
      }
    });
    return result;
  }

  // ปรับเปลี่ยนการแสดงปุ่ม
  function showDetail(mode, id) {
    switch (mode) {
      case "show":
        domID(`detail-show-${id}`).style.display = "block";
        domID(`chevronDown-${id}`).style.display = "none";
        domID(`chevronUp-${id}`).style.display = "block";
        break;
      case "hide":
        domID(`detail-show-${id}`).style.display = "none";
        domID(`chevronDown-${id}`).style.display = "block";
        domID(`chevronUp-${id}`).style.display = "none";
        break;
    }
  }

  // เมื่อยืนยันการประเมิน
  function handelConfrimT(e) {
    e.preventDefault();
    let lenghtPoint = radioPoint.length;
    let lenghtSheet = detailSheet.length;

    // console.log("this is", getEditOldDB);

    if (statusUpdate) {
      // console.log(
      //   "edit and save it sent to UPDATE !!!!",
      //   radioPoint,
      //   detailSheet
      // );
      if (lenghtPoint !== lenghtSheet)
        return Swal.fire({
          icon: "error",
          title: "การประเมินไม่เรียบร้อย",
          text: "กรุณาทำแบบประเมินให้ครบ!!!",
          showConfirmButton: false,
          timer: 1300,
        });
      // ---อัพเดทข้อมูลนักศึกษา
      fetchWorkDetail(idOfStudent, workId).then((res) => {
        res.json().then((data) => {
          // console.log("this data =>", data);
          radioPoint.map((rp, index) => {
            // console.log(
            //   "this is data to UPDATE ->",
            //   data[0].Id,
            //   rp.IDfrom,
            //   rp.value
            // );
            fetchUpdateWorkScore(data[0].Id, rp.IDfrom, rp.value);
          });
        });
      });
      fetchCommentWorkDetail(commentgroup, workId, idOfStudent).then((res) =>
        res
          .json()
          .then((message) => {
            if (message) {
              console.log(message);
            }
          })
          .catch((err) => {
            console.error("comment fail", err);
          })
      );
      uploadImagecomment();
      uploadPDFcomment();
      props.setImageURL([]);
      props.setPdfcomment([]);
      Swal.fire({
        icon: "success",
        title: "แก้ไขการประเมินสำเร็จ",
        text: "บันทึกการประเมินเรียบร้อย",
        showConfirmButton: false,
        timer: 1300,
      });

      handelBackToservice(grp, sheet, workId, id);
    } else {
      if (radioPoint) {
        if (lenghtPoint === lenghtSheet) {
          // console.log("OH yes almost done!!!!!", radioPoint);
          // ---เพิ่มข้อมูลประเมินนักศึกษา
          // console.log("justtryDATAtoWorkDetail==>", workId, idOfStudent);
          if (sheet.toString() === "5" || sheet.toString() === "6") {
            // console.log(sheet);
            // console.log(
            //   "อะไรอีกครับ!!!!!",
            //   workId,
            //   idOfStudent,
            //   advisor.advisor_id
            // );
            fetchAddWorkDetail(workId, idOfStudent, advisor.advisor_id);
          }

          setTimeout(() => {
            fetchWorkDetail(idOfStudent, workId).then((res) => {
              res.json().then((data) => {
                // console.log("oh --->", data);
                radioPoint.map((rp, index) => {
                  // console.log(
                  //   "indexที่",
                  //   index,
                  //   "ค่าจะส่งคือ",
                  //   data[0].Id,
                  //   rp.IDfrom,
                  //   rp.value
                  // );
                  fetchAddWorkScore(data[0].Id, rp.IDfrom, rp.value);
                });
              });
            });
          }, 500);
          fetchCommentWorkDetail(commentgroup, workId, idOfStudent).then(
            (res) =>
              res
                .json()
                .then((message) => {
                  if (message) {
                    console.log(message);
                  }
                })
                .catch((err) => {
                  console.error("comment fail", err);
                })
          );
          uploadImagecomment();
          uploadPDFcomment();
          props.setImageURL([]);
          props.setPdfcomment([]);
          Swal.fire({
            icon: "success",
            title: "การประเมินเรียบร้อย",
            text: "บันทึกการประเมินเรียบร้อย",
            showConfirmButton: false,
            timer: 1300,
          }).then(() => {
            handelBackToservice(grp, sheet, workId, id);
          });
        } else {
          // console.log("--->dshet", lenghtSheet, detailSheet);
          // console.log("--->point", lenghtPoint, radioPoint);
          Swal.fire({
            icon: "error",
            title: "การประเมินไม่เรียบร้อย",
            text: "กรุณาทำแบบประเมินให้ครบ!!!",
            showConfirmButton: false,
            timer: 1300,
          });
        }
      }
    }
  }

  // การกับไปทำงานเมื่อใดๆ
  function handelBackToservice(grp, sheet, workId, idstd) {
    let data = JSON.parse(localStorage.getItem("highlight"));

    if (!grp || grp === "null" || grp === "") {
      localStorage.removeItem("getFloat");
      return navigat(`/listWork?timestamp=${new Date().getTime()}`);
    }

    if (data) {
      let pass = false;
      data.map((data) => {
        // console.log("--->", data.studentID, idstd);
        if (data.studentID.trim() === idstd.trim()) {
          // console.log("ไม่เท่ากับ");
          pass = true;
        }
      });
      if (pass) {
        localStorage.removeItem("getFloat");
        navigat(
          `/grouplistHL/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
        );
      } else {
        localStorage.removeItem("getFloat");
        navigat(`/listWork?timestamp=${new Date().getTime()}`);
      }
    } else {
      localStorage.removeItem("getFloat");
      navigat(
        `/grouplist/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
      );
    }
  }

  // ละทิ้งการประเมิน
  function handlecheckAbandon(status) {
    if (status) {
      Swal.fire({
        title: "ละทิ้งการประเมิน!",
        text: "ต้องการละทิ้งการประเมินครั้งนี้ ใช่ หรือ ไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#396a8d",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log("มีข้อมูลอยู่นะ จะทิ้งการประเมินใช่ หรือ ไม่");
          localStorage.removeItem("cry");
          setStartEstimate(false);
          handelBackToservice(grp, sheet, workId, id);
        }
      });
    } else {
      // console.log("ไปเถอะ ไม่มีการประเมินอะไรทั้งนั้น ");
      localStorage.removeItem("cry");
      handelBackToservice(grp, sheet, workId, id);
    }
  }

  // เปลี่ยนสีหัวเรื่อง
  function handleChangeColorEdit() {
    document.getElementById("NavAssesment").style.backgroundColor = "#ff8f00";
    document.getElementById("btn-submit-content").style.backgroundColor =
      "#ff8f00";
  }

  window.onscroll = () => {
    if (!document.getElementById("titleDetailFrom")) return;
    let navbar = document.getElementById("navbar").offsetHeight;
    let sticky = document.getElementById("titleDetailFrom").offsetTop - navbar;
    if (window.scrollY >= sticky) {
      document.getElementById("titleDetailFrom").style.position = "fixed";
      document.getElementById("titleDetailFrom").style.top = `${navbar}px`;
    }
    if (window.scrollY < document.getElementById("offFixed").offsetTop) {
      document.getElementById("titleDetailFrom").style.position = "static";
    }
  };

  return (
    <div className="assessment-wardround">
      <form>
        <div className="nav" id="navbar">
          {detailStudent[0]
            ? detailStudent.map((data, index) => (
                <div key={index}>
                  <div
                    className="nav-wardround-student-highlight"
                    id="NavAssesment"
                  >
                    <div className="box-relative">
                      <i
                        className="icon-footer-nav bi-chevron-left"
                        onClick={() => {
                          setHidefloatpoint(false);
                          handlecheckAbandon(startEstimate);
                          props.setImageURL([]);
                          setStatusUpdate(false);
                          localStorage.removeItem("point_radio");
                          localStorage.removeItem("stu_e");
                          localStorage.removeItem("cmm");
                        }}
                      ></i>
                    </div>
                    <div>
                      <span>
                        {`${detailSheetName ? detailSheetName[0].name : ""}`}{" "}
                      </span>
                    </div>
                    <div
                      style={
                        statusWork ? { display: "none" } : { display: "block" }
                      }
                    >
                      <i
                        className={`bi-pencil-square ${
                          getEditOldDB ? "" : "hidden"
                        }`}
                        onClick={() => {
                          setTimeout(() => {
                            handleChangeColorEdit();
                            setStatusHaveScore(false);
                            // setRadioPoint("");
                            setGetEditOldDB(false);
                            setStatusUpdate(true);
                            setTextEdit("บันทึกแก้ไข");
                          }, 200);
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              ))
            : ""}
        </div>
        <div className="content">
          {detailSheet[0] ? (
            <div className="content-assessment-wardround">
              {handleShowHead(sheet)}
              {filenameStudent[0]
                ? filenameStudent.map((file, index) => (
                    <div className="pdf-content" key={index}>
                      <div className="grid-header-conentpdf">
                        <h2>PDF</h2>
                        <div className="box-date-pdf">
                          <span>
                            {moment(file.date)
                              .add(543, "year")
                              .format("DD/MM/YY")}
                          </span>
                        </div>
                      </div>
                      <div
                        className="card-pdf"
                        onClick={() => {
                          window.open(
                            `${http_mvc}/images/${new Date(file.date).getFullYear()}/${workId}/${
                              file.file_name
                            }?timestamp=${new Date().getTime()}`,
                            "_self"
                          );
                        }}
                      >
                        <div className="card-pdf-namefile">
                          <span>{`รายงาน : ${file.file_name}`}</span>
                        </div>
                        <div className="card-pdf-linkfile">
                          <a
                            onClick={() => {
                              window.open(
                                `${http_mvc}/images/${new Date(file.date).getFullYear()}/${workId}/${
                                  file.file_name
                                }?timestamp=${new Date().getTime()}`,
                                "_self"
                              );
                            }}
                          >
                            <i
                              className="bi-filetype-pdf"
                              // onClick={() => {
                              //   navigat(`/viewPDF/${id}/${grp}/${sheet}/${workId}`);
                              // }}
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
              <div id={"offFixed"}></div>
              <div className="title-header-form" id={"titleDetailFrom"}>
                <div className="title-show-header">
                  <h3>หัวข้อประเมิน</h3>
                  <h3>คะแนน</h3>
                </div>
                <div className="detailPoint-show">
                  {/* {detailPoint[0]
                ? detailPoint.map((res, index) => (
                    <span key={index}>{`${res.text} = ${res.point} `}</span>
                  ))
                : ""} */}
                </div>
              </div>
              {detailSheet[0] ? (
                detailSheet.map((dataSheet, key) => (
                  <div className="card-assessment-wardround" key={key}>
                    <div className="text-content-assessment">
                      <div className="txt-data-detail">
                        <div className="box-show-datasheet">
                          <div className="text-show-detailsheet">
                            {/* ใช้ - \n \t ในการตัดค่า */}
                            {/* {console.log(dataSheet.txt.split("\r"))} */}
                            {sheet === "5"
                              ? dataSheet.txt
                              : dataSheet.txt.split("\r")[0]}
                          </div>
                          <div className="caretDown-btn">
                            <div>
                              <i
                                className="bi-caret-down-fill"
                                id={`chevronDown-${key}`}
                                style={
                                  sheet !== "5"
                                    ? dataSheet.txt.split("\r")[1]
                                      ? { display: "block" }
                                      : { display: "none" }
                                    : { display: "none" }
                                }
                                onClick={() => {
                                  showDetail("show", key);
                                }}
                              ></i>
                              <i
                                className="bi-caret-up-fill showUP"
                                id={`chevronUp-${key}`}
                                onClick={() => {
                                  showDetail("hide", key);
                                }}
                              ></i>
                            </div>
                          </div>
                        </div>

                        <div className="detailShow" id={`detail-show-${key}`}>
                          {dataSheet.txt.split("\r").map((res, index) => {
                            if (index !== 0) {
                              return (
                                <p key={index}>
                                  {res.split("?") ? res.split("?") : res}
                                </p>
                              );
                            }
                          })}
                        </div>
                      </div>
                      <div className="radio-btn-box">
                        <div className="point-box-show" id={"thisshowpoint"}>
                          {pointArr[0]
                            ? pointArr.map((data) => {
                                return data.map((ele, index) => {
                                  if (ele.sheetDetailId === dataSheet.ID) {
                                    return <span key={index}>{ele.score}</span>;
                                  }
                                });
                              })
                            : ""}
                          <div
                            className={`pointchange ${
                              hidefloatpoint === true ? "" : "hidden"
                            }`}
                          >
                            <i
                              className="bi-chevron-left showfloat"
                              id={`icon-chevron-left-${dataSheet.ID}`}
                              onClick={() => {
                                if (localStorage.getItem("getFloat")) {
                                  let dataId = JSON.parse(
                                    localStorage.getItem("getFloat")
                                  );
                                  let resultNew = [];
                                  dataId.map((ele) => {
                                    if (ele.IDsheet !== dataSheet.ID) {
                                      resultNew.push(ele);
                                    }
                                  });

                                  localStorage.setItem(
                                    "getFloat",
                                    JSON.stringify(resultNew)
                                  );
                                }
                                // handleCutValuePoint(key);
                                handleSwitchPoint("int", key, dataSheet.ID);
                              }}
                            ></i>
                            <i
                              className={`bi-chevron-right`}
                              id={`icon-chevron-right-${dataSheet.ID}`}
                              onClick={() => {
                                if (localStorage.getItem("getFloat")) {
                                  let dataId = JSON.parse(
                                    localStorage.getItem("getFloat")
                                  );

                                  if (!dataId[0]) {
                                    // alert("เงื่อนไขมีสโตแต่ไม่มีข้อมูล");
                                    localStorage.setItem(
                                      "getFloat",
                                      JSON.stringify([
                                        { IDsheet: dataSheet.ID },
                                      ])
                                    );
                                  } else {
                                    let pass = true;
                                    dataId.map((ele) => {
                                      if (ele.IDsheet === dataSheet.ID) {
                                        pass = false;
                                      }
                                    });
                                    if (pass) {
                                      // alert("เงื่อนไข idsheet  ไม่ซ้ำ");
                                      dataId.push({ IDsheet: dataSheet.ID });
                                      localStorage.setItem(
                                        "getFloat",
                                        JSON.stringify(dataId)
                                      );
                                    }
                                  }
                                } else {
                                  // alert("เข้าเงื่อนไขไม่มีสโต");
                                  localStorage.setItem(
                                    "getFloat",
                                    JSON.stringify([{ IDsheet: dataSheet.ID }])
                                  );
                                }
                                // handleCutValuePoint(key);
                                handleSwitchPoint("float", key, dataSheet.ID);
                              }}
                            ></i>
                          </div>
                        </div>
                        <div className="this-point" id={"thispointbox"}>
                          {pointArr.map((data, kor) => {
                            return data.map((ele, index) => {
                              if (ele.sheetDetailId === dataSheet.ID) {
                                return (
                                  <div className="btn-radio" key={index}>
                                    <input
                                      className="radioPointInput"
                                      id={`input-radio-${index}`}
                                      type={"radio"}
                                      value={ele.score}
                                      onChange={() => {
                                        setStartEstimate(true);
                                        // handleCutValuePoint(key);
                                        checkRadioButton(
                                          radioPoint,
                                          key,
                                          ele.sheetDetailId,
                                          index,
                                          ele.score,
                                          dataSheet.ID
                                        );
                                      }}
                                      checked={
                                        // switchpoint
                                        //   ? false
                                        //   : radioChecked(radioPoint, key, index) === true
                                        radioChecked(
                                          radioPoint,
                                          dataSheet.ID,
                                          ele.score
                                        ) === true
                                      }
                                      disabled={getEditOldDB}
                                    ></input>
                                  </div>
                                );
                              }
                            });
                          })}
                          <div>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div></div>
              )}
              {sheet === "6" || sheet === "5" ? (
                <div className="box-comment-sheet">
                  <div className="boxcomment-preview">
                    <div className="text-comment">
                      <span>หมายเหตุ : </span>
                    </div>
                    <div className="input-textArea">
                      <textarea
                        onChange={(e) => {
                          setCommentgroup(e.target.value);
                        }}
                        value={commentgroup}
                        readOnly={getEditOldDB ? true : false}
                        style={{ height: "100px" }}
                      ></textarea>
                    </div>
                  </div>
                  <div
                    className="btn-comment-sheet"
                    style={getEditOldDB ? { display: "none" } : {}}
                  >
                    {/* <h3>{"แนบรูปภาพ"}</h3> */}
                    {/* ปุ่มกล้อง */}
                    <button
                      type="button"
                      style={{ fontSize: "25px" }}
                      onClick={() => {
                        if (radioPoint[0]) {
                          localStorage.setItem(
                            "point_radio",
                            JSON.stringify(radioPoint)
                          );
                        }
                        if (statusUpdate) {
                          localStorage.setItem("stu_e", JSON.stringify(true));
                        }
                        // console.log("cmm", commentgroup);
                        if (commentgroup) {
                          localStorage.setItem(
                            "cmm",
                            JSON.stringify(commentgroup)
                          );
                        }
                        navigat(
                          `/camaravideo/${id}/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
                        );
                      }}
                    >
                      <Icon icon="ph:camera-thin" />
                    </button>
                    {/* ปุ่มแนบรูปภาพจากเครื่อง */}
                    <button
                      type="button"
                      style={{ fontSize: "25px", color: "#414040" }}
                      onClick={() => {
                        document
                          .getElementById("inputfiles-imagesheet")
                          .click();
                      }}
                    >
                      {/* <Icon icon="bi:image-alt" /> */}
                      {/* <Icon icon="tdesign:image-1" /> */}
                      <Icon icon="lets-icons:img-alt-light" />
                    </button>
                    <button
                      type="button"
                      style={{ fontSize: "20px", color: "#414040" }}
                      onClick={() => {
                        document.getElementById("inputfiles-pdfsheet").click();
                      }}
                    >
                      <i className="bi-filetype-pdf"></i>
                    </button>
                    <input
                      type="file"
                      id="inputfiles-imagesheet"
                      accept="image/jpeg"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        // console.log("value files >", e.target.files);
                        // setFileimgcomment(e.target.files[0]);
                        handlefilereader(e.target.files[0]);
                      }}
                    ></input>
                    <input
                      type="file"
                      id="inputfiles-pdfsheet"
                      accept=".pdf"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        // console.log("value files >", e.target.files);
                        // setFileimgcomment(e.target.files[0]);
                        handlefilereader(e.target.files[0]);
                      }}
                    ></input>
                  </div>
                  <div className="perview_image">
                    {datashowImgcom[0]
                      ? datashowImgcom.map((res_showimg, key_res_showing) => {
                          return (
                            <div
                              className="box-img-perview"
                              key={key_res_showing}
                            >
                              <img
                                src={res_showimg}
                                onClick={() => {
                                  Swal.fire({
                                    imageUrl: `${res_showimg}`,
                                    showConfirmButton: false,
                                    showCloseButton: true,
                                    background: "none",
                                  });
                                }}
                              ></img>
                            </div>
                          );
                        })
                      : ""}
                    {props.ImageURL[0]
                      ? props.ImageURL.map((res_img, key) => {
                          return (
                            <div className="box-img-perview" key={key}>
                              <img
                                src={res_img}
                                onClick={() => {
                                  Swal.fire({
                                    imageUrl: `${res_img}`,
                                    showConfirmButton: false,
                                    showCloseButton: true,
                                    background: "none",
                                  });
                                }}
                              ></img>

                              <button
                                type="button"
                                className="btn-cancel-img"
                                onClick={() => {
                                  Swal.fire({
                                    title: "ลบรูปภาพ!!",
                                    text: "ท่าต้องการ ลบรายการ ใช่ หรือ ไม่ ?",
                                    icon: "warning",
                                    confirmButtonText: "ตกลง",
                                    showCancelButton: true,
                                    cancelButtonText: "ยกเลิก",
                                  }).then((isConfirmed) => {
                                    if (isConfirmed.isConfirmed) {
                                      handleDeleteimageset(key);
                                    }
                                  });
                                }}
                              >
                                <Icon icon="fa:close" />
                              </button>
                            </div>
                          );
                        })
                      : ""}
                    {datashowPDFcom[0]
                      ? datashowPDFcom.map((get_pdf, keyget_pdf) => {
                          return (
                            <div
                              className="box-img-perview"
                              key={`pdf${keyget_pdf}`}
                              onClick={() => {
                                setUrlframeshowmodal(get_pdf);
                              }}
                            >
                              <div className="boxpdfimg">
                                <div className="boxpdfimg-icon-pdf">
                                  <i className="bi-filetype-pdf"></i>
                                </div>
                                <p>
                                  <span>{get_pdf.split("/")[7]}</span>
                                </p>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                    {props.Pdfcomment[0]
                      ? props.Pdfcomment.map((res_pdf, key_pdf) => {
                          return (
                            <div
                              className="box-img-perview"
                              key={`pdf${key_pdf}`}
                            >
                              <div
                                className="boxpdfimg"
                                onClick={() => {
                                  Swal.fire({
                                    title: "ไฟล์ PDF.",
                                    text: `ไฟล์ชื่อ ${res_pdf.filename}`,
                                  });
                                }}
                              >
                                <div className="boxpdfimg-icon-pdf">
                                  <i className="bi-filetype-pdf"></i>
                                </div>
                                <p>
                                  <span>{res_pdf.filename}</span>
                                </p>
                              </div>
                              <button
                                type="button"
                                className="btn-cancel-img"
                                onClick={() => {
                                  Swal.fire({
                                    title: "ลบPDF!!",
                                    text: "ท่าต้องการ ลบรายการ ใช่ หรือ ไม่ ?",
                                    icon: "warning",
                                    confirmButtonText: "ตกลง",
                                    showCancelButton: true,
                                    cancelButtonText: "ยกเลิก",
                                  }).then((isConfirmed) => {
                                    if (isConfirmed.isConfirmed) {
                                      handleDeletePdfset(key_pdf);
                                    }
                                  });
                                }}
                              >
                                <Icon icon="fa:close" />
                              </button>
                            </div>
                          );
                        })
                      : ""}
                  </div>
                </div>
              ) : (
                <div className="box-comment-sheet">
                  <div className="boxcomment-preview">
                    <div className="text-comment">
                      <span>คอมเม้น : </span>
                    </div>
                    <div className="input-textArea">
                      <textarea
                        onChange={(e) => {
                          setCommentgroup(e.target.value);
                        }}
                        value={commentgroup}
                        readOnly={getEditOldDB ? true : false}
                      ></textarea>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className="footer-nav-assessment"
          style={statusHaveScore ? { display: "none" } : { display: "block" }}
        >
          <div></div>
          <div className="box-relative">
            <button
              type="submit"
              id="btn-submit-content"
              className={`btn-continue ${getEditOldDB ? "hidden" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                if (statusUpdate) {
                  Swal.fire({
                    title: "แก้ไขการประเมิน",
                    text: "ต้องการแก้ไขข้อมูลการประเมิน ใช่ หรือ ไม่",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#33691e",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ตกลง",
                    cancelButtonText: "ยกเลิก",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handelConfrimT(e);
                    }
                  });
                } else {
                  handelConfrimT(e);
                }
              }}
            >
              {`${textEdit ? textEdit : "บันทึก"}`}
            </button>
          </div>
        </div>
      </form>
      <div
        className="modal-showiframepdf"
        id="modalshowiframpdf"
        ref={refshowiframepdf}
      >
        <div className="btn-close-showiframepdf">
          <button
            type="button"
            onClick={() => {
              document.getElementById("modalshowiframpdf").style.display =
                "none";
              setUrlframeshowmodal("");
            }}
          >
            <Icon icon="ep:close-bold" />
          </button>
        </div>
        <div className="content-showiframepdf">
          <iframe src={urliframeshowmodal}></iframe>
        </div>
      </div>
      <div className="modal-showloadingpdf" id="modashowloadingpdf">
        <div className="divcontentboxloading">
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WardRoundAssessmentPage;
